import React from 'react'

const LocationPointerIcon = (props) => {
  const { size, color } = props
  return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 512 512">
      <path
        fill={color}
        d="M247 5.7c-68.1 4.8-124 53.6-137.5 119.8-7.3 35.9-1.1 64.6 25.1 116.9 17.3 34.4 48 83.6 80.3 128.9 13.2 18.5 16 21.9 21.5 25.6 7.2 4.8 12.8 6.3 21.9 5.9 15.3-.7 21.2-5.4 39.3-30.6 56-78.3 93.9-146.9 105.4-190.7 7.3-28.3 3-62.1-11.7-92C376.8 60.1 354 36.9 324.9 22c-18.1-9.3-35-14.1-56-16-11.2-1-12.7-1-21.9-.3zm31.5 68.1c25 6.7 46.2 23.9 57.7 46.7 1.4 2.7 3.8 8.8 5.4 13.5 2.6 8 2.8 9.6 2.9 25.5 0 16.6-.1 17.2-3.3 27.1-12.3 37.5-45.6 61.8-84.7 61.8-25 0-44.7-8.3-62.5-26.3-13.4-13.6-21.1-27.7-24.6-45-2.2-11.2-1.5-30.4 1.6-41.1 4.7-16.7 16.1-34.1 29.2-44.7 11.5-9.3 27.6-16.6 42.5-19.3 7.5-1.4 27.8-.4 35.8 1.8z"
      />
      <path
        fill={color}
        d="M243.2 107.6c-9.6 2.5-16.4 6.6-24.3 14.4-11.6 11.5-16.1 22.4-16 38.5.1 14.9 4.9 26.1 15.7 37.1 24.4 24.7 63.7 20.6 83.3-8.7 10.1-15.2 11.3-36.8 2.9-53.4-4.8-9.4-15-19.5-24.3-24-11-5.4-26.1-7-37.3-3.9zM119 320.2c-68 15.6-109.8 42.2-117.5 75-12 50.9 56.2 92.6 174.5 106.7 28.7 3.5 46.6 4.4 80 4.4s51.3-.9 80-4.4c118.3-14.1 186.5-55.8 174.5-106.7-6.5-27.3-35.2-49.6-85.5-66.2-12.4-4.1-50.9-13.7-51.4-12.8-.1.2-5.7 8.8-12.4 19.1-6.8 10.4-12.4 19.3-12.5 19.9-.1.6 6.1 2.2 14.8 3.8 25 4.6 46.2 10.6 66.5 18.8 17.2 6.9 32.9 17.5 36.3 24.4 1.6 3.3 1.6 4 .4 7-2.6 6.1-12 13.4-27.2 20.8-30.2 14.8-66.8 23.8-121 29.7-23.1 2.5-101.9 2.5-125 0-54.2-5.9-90.8-14.9-121-29.7-15.2-7.4-24.6-14.7-27.2-20.8-1.2-3-1.2-3.7.4-7 3.4-6.9 19.1-17.5 36.3-24.4 20.3-8.2 41.8-14.3 66.1-18.7 8-1.4 14.8-3 15-3.4.6-1.1-24.4-39.6-25.6-39.6-.5 0-8.9 1.9-18.5 4.1z"
      />
    </svg>
  )
}

LocationPointerIcon.defaultProps = {
  size: 30,
  color: '#555555',
}

export default LocationPointerIcon
